module.exports = __webpack_public_path__ + "img/icon-circled-arrow.bc04d6e9.svg";